const authProvider = {
  login: ({ username, password }) => {
    const request = new Request(`${process.env.REACT_APP_API}/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ access_token: token, role }) => {
        localStorage.setItem('access_token', token);
        localStorage.setItem('permissions', role);
        localStorage.setItem('identity', username);
      })
      .catch(() => {
        throw new Error('Network error');
      });
  },
  checkAuth: () =>
    localStorage.getItem('access_token')
      ? Promise.resolve()
      : Promise.reject({ message: false }),
  checkError: (error) => {
    const { status } = error;
    if (status === 401 || status === 403) {
      localStorage.removeItem('access_token');
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  logout: () => {
    localStorage.removeItem('access_token');
    return Promise.resolve();
  },
  getIdentity: () => {
    try {
      const username = localStorage.getItem('identity');
      return Promise.resolve(username);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getPermissions: () => {
    const role = localStorage.getItem('permissions');
    return role ? Promise.resolve(role) : Promise.reject();
  },
};

export default authProvider;
